"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = UserAvatar;
var _Avatar2 = _interopRequireDefault(require("@mui/material/Avatar"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _icons = require("../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const colors = ['#2AC682', '#BB8A1A', '#528BE8', '#F36565', '#FA823E', '#DD428D', '#CF58E1', '#743AEF', '#1589BB', '#268B1D', '#846858'];
function UserAvatar(_ref) {
  let {
    size,
    bgColor,
    color,
    user: {
      profilePicture,
      username
    }
  } = _ref;
  let firstLetter = username && String.fromCodePoint(username.codePointAt(0) || 0);
  if (firstLetter?.match(/[a-z]/i)) firstLetter = firstLetter?.toUpperCase();
  return profilePicture ? /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    src: profilePicture,
    sx: {
      height: size || 32,
      width: size || 32
    }
  }) : /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    sx: _ref2 => {
      let {
        palette
      } = _ref2;
      return {
        bgcolor: bgColor || (firstLetter ? (0, _styles.lighten)(colors[firstLetter.charCodeAt(0) % colors.length], 0.8) : palette.primary.light),
        color: color || (firstLetter ? colors[firstLetter.charCodeAt(0) % colors.length] : palette.primary.light),
        fontSize: size && typeof size === 'number' && size >= 48 ? '1.5rem' : undefined,
        fontWeight: size && typeof size === 'number' && size >= 48 ? 700 : undefined,
        height: size || 32,
        width: size || 32
      };
    }
  }, firstLetter || /*#__PURE__*/_react.default.createElement(_icons.PersonIcon, {
    fontSize: "small",
    sx: {
      color: '#fff'
    }
  }));
}